import React from 'react';
import PropTypes from 'prop-types';

export default function BtnToggleFilter({ show, handleShow }) {
  return (
    <div className="col-12 col-md-auto d-inline text-center text-md-end mt-md-0 mt-2">
      <button type="button" onClick={handleShow} className="btn btn-sm btn-sm background-rojo-megatone">
        <i className="fa fa-filter" /> {show ? "Ocultar Filtro" : "Mostrar Filtro"}
      </button>
    </div>
  )
}
BtnToggleFilter.propTypes = {
    show: PropTypes.bool.isRequired,
    handleShow: PropTypes.func.isRequired
}